import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserPhoto } from '@shared/services/photo/model/photo.model';
import { CameraSquareActions } from '../camera-uploader-square/camera-square-actions.enum';
import { SquareClickedEvent } from './square-click.interface';
import { combineLatest, map, Observable, of } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-camera-uploader',
  templateUrl: './camera-uploader.component.html',
  styleUrls: ['./camera-uploader.component.scss'],
})
export class CameraUploaderComponent implements OnInit {
  @Input() photos: Observable<UserPhoto[]>;
  @Input() squaresLimit: Observable<number> = of(3);
  @Input() errorState: string;
  @Output() squareClicked = new EventEmitter();
  cameraActions = CameraSquareActions;
  squaresArray: Observable<any> = of([]);

  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.squaresArray = combineLatest([this.photos, this.squaresLimit]).pipe(
      map(([photos, limit]) => {
        let updatedPhotosWithSafeUrl = photos.map((photo: UserPhoto) => {
          return {
            ...photo,
            safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
              photo.webviewPath,
            ),
          };
        });
        return [
          ...updatedPhotosWithSafeUrl,
          ...new Array(limit - photos.length).fill(undefined),
        ];
      }),
    );
  }

  handleSquareClicked(event: string, index: number) {
    let clickedObject: SquareClickedEvent = { event: event, index: index };
    this.squareClicked.emit(clickedObject);
  }
}
